(() => {
  let isSyncing = false;
  let debounceTimer = null;
  const COOLDOWN_MS = 4000;
  const recentlyAppliedByKey = new Map();

  const getSellingPlanId = (item) => item?.selling_plan_allocation?.selling_plan?.id || '';

  const computePropertiesUpdate = (item) => {
    const properties = item?.properties || {};
    const currentWidgetId = properties._widget_id;
    const isCurrentlyTagged = currentWidgetId === 'multipacks' && properties._source === 'YK';

    const hasSellingPlan = Boolean(item?.selling_plan_allocation);
    const isMultipackItem = Boolean(window.YkMultipackDiscount?.isMultipackItem?.(item));
    const quantity = Math.max(1, Number(item?.quantity) || 0);
    const percent = isMultipackItem ? window.YkMultipackDiscount?.getDiscountPercentForQty?.(item, quantity) : null;
    const isEligible = !hasSellingPlan && Boolean(percent);

    if (isEligible && !isCurrentlyTagged && (!currentWidgetId || currentWidgetId === 'multipacks')) {
      return { ...properties, _source: 'YK', _yk_source: 'YK', _widget_id: 'multipacks' };
    }

    if (!isEligible && isCurrentlyTagged) {
      return { ...properties, _source: '', _yk_source: '', _widget_id: '' };
    }

    return null;
  };

  const syncMultipackProperties = async () => {
    if (isSyncing) return;
    const Cart = window.Rebuy?.Cart;
    if (!Cart) return;

    const items = Array.isArray(window.Rebuy?.SmartCart?.cart?.items) ? window.Rebuy.SmartCart.cart.items : [];

    isSyncing = true;
    try {
      for (const item of items) {
        const nextProperties = computePropertiesUpdate(item);
        if (!nextProperties) continue;

        const sellingPlanId = getSellingPlanId(item);
        const signature = JSON.stringify({ sellingPlanId, nextProperties });
        const now = Date.now();
        const recent = recentlyAppliedByKey.get(item.key);
        if (recent && recent.signature === signature && now < recent.expiresAt) continue;
        recentlyAppliedByKey.set(item.key, { signature, expiresAt: now + COOLDOWN_MS });

        await Cart.changeItem({
          id: item.key,
          quantity: item.quantity,
          properties: nextProperties,
          selling_plan: sellingPlanId,
        });
      }
    } finally {
      isSyncing = false;
    }
  };

  const scheduleSync = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncMultipackProperties, 300);
  };

  document.addEventListener('rebuy:cart.change', scheduleSync);
  document.addEventListener('rebuy:cart.enriched', scheduleSync);
})();
